export class QuestInfoModel {
  constructor(
    public id = 0,
    public travelPathwayID = 0,
    public applicantName = "",
    public eympCaseID = "",
    public homeCompanyName = "",
    public destCompanyCode = "",
    public destinationCompanyName = "",
    public zoomProfileID = "",
    public zoomCaseID = "",
    public caseType = "",
    public caseSubType = "",
    public caseSubSubType = "",
    public serviceCountry = "",
    public clientName = "",
    public clientGUID = "",
  ) { }
}
